import { cn } from "@/lib/utils";

interface BackgroundOrbsProps {
  /** Tailwind opacity class, e.g. "opacity-50" */
  opacity?: string;
  /** Tailwind bg class for the top-right orb (default indigo-50) */
  topColor?: string;
  /** Tailwind bg class for the bottom-left orb (default fuchsia-50) */
  bottomColor?: string;
  /** Adds a centered subtle accent orb (fuchsia) for layouts that need a brand cue */
  withAccent?: boolean;
  className?: string;
}

export function BackgroundOrbs({
  opacity = "opacity-50",
  topColor = "bg-indigo-50",
  bottomColor = "bg-fuchsia-50",
  withAccent = false,
  className,
}: BackgroundOrbsProps) {
  return (
    <div
      aria-hidden="true"
      className={cn("pointer-events-none absolute inset-0 overflow-hidden", className)}
    >
      <div
        className={cn(
          "absolute top-0 right-0 w-[500px] h-[500px] rounded-full blur-3xl -mr-64 -mt-64",
          topColor,
          opacity,
        )}
      />
      <div
        className={cn(
          "absolute bottom-0 left-0 w-[500px] h-[500px] rounded-full blur-3xl -ml-64 -mb-64",
          bottomColor,
          opacity,
        )}
      />
      {withAccent && (
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] rounded-full blur-3xl bg-[#c026d3]/5" />
      )}
    </div>
  );
}
